module.exports = __webpack_public_path__ + "static/media/background_start.b0b7914f.jpg";